<template>
  <div>
    <audio :src="audioUrl" @ended="onEnded" controls></audio>
    <!--    <button @click="playAudio">播放音频</button>-->
    <!--    <button @click="pauseAudio">暂停音频</button>-->

  </div>
</template>

<script setup>
// import {ref} from 'vue';

const audioUrl = require('@/assets/sound/correct.mp3'); // 音频文件的URL
// const audioPlayer = ref(null);

// const audio = new Audio(require('@/assets/sound/FireEngine/questionAudio/central/centralSearchHistoryRecord.mp3'));

// audio.play();
// const playAudio = () => {
//   audioPlayer.value.play();
// };

// const pauseAudio = () => {
//   audioPlayer.value.pause();
// };

const onEnded = () => {
  // 音频播放结束时的逻辑
  console.log('音频播放结束');
};

// onMounted(() => {
//   audioPlayer.value.play();
// });
</script>
